export default "<p>payment works!</p>\n";